import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, finalize } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Membership,businessSector } from '../_models/';

const baseUrl = `${environment.apiUrl}/membership`;
const bsUrl = `${environment.apiUrl}/sector`;

@Injectable({ providedIn: 'root' })
export class MembershipService {
    private membershipSubject: BehaviorSubject<Membership>;
    public membership: Observable<Membership>;
    private businessSectorSubject: BehaviorSubject<businessSector>;
    public businessSector: Observable<businessSector>;

    constructor(
        private router: Router,
        private http: HttpClient
    ) {
        this.membershipSubject = new BehaviorSubject<Membership>(null);
        this.membership = this.membershipSubject.asObservable();
        this.businessSectorSubject = new BehaviorSubject<businessSector>(null);
        this.businessSector = this.membershipSubject.asObservable();
    }

    public get membershipValue(): Membership {
        return this.membershipSubject.value;
    }
    public get businessSectorValue(): businessSector {
        return this.businessSectorSubject.value;
    }

    register(membership: Membership) {
        return this.http.post(`${baseUrl}/register`, membership);
    }

    getAll() {
        return this.http.get<Membership[]>(baseUrl);
    }

    getById(id: string) {
        return this.http.get<Membership>(`${baseUrl}/${id}`);
    }
    
    create(params) {
        return this.http.post(baseUrl, params);
    }
    
    update(id, params) {
        return this.http.put(`${baseUrl}/${id}`, params)
            .pipe(map((membership: any) => {
                    // publish updated membership to subscribers
                    membership = { ...this.membershipValue, ...membership };
                    this.membershipSubject.next(membership);
              
                return membership;
            }));
    }
    delete(id: string) {
        return this.http.delete(`${baseUrl}/${id}`)
            .pipe(finalize(() => {
            }));
    }
    getAllBusinessSector() {
        return this.http.get<businessSector[]>(bsUrl);
    }

    getBsById(id: string) {
        return this.http.get<businessSector>(`${bsUrl}/${id}`);
    }
    
    createBs(params) {
        return this.http.post(bsUrl, params);
    }
    
    updateBs(id, params) {
        return this.http.put(`${bsUrl}/${id}`, params)
            .pipe(map((businessSector: any) => {
                    // publish updated membership to subscribers
                    businessSector = { ...this.businessSectorValue, ...businessSector };
                    this.businessSectorSubject.next(businessSector);
              
                return businessSector;
            }));
    }
    deleteBs(id: string) {
        return this.http.delete(`${bsUrl}/${id}`)
            .pipe(finalize(() => {
            }));
    }
   

    
}